// extracted by mini-css-extract-plugin
export default {"header-tip-wrap":"wx-modal_header-tip-wrap__gQV+q","header-tip":"wx-modal_header-tip__zZlSP"};